<template>
  <div class="footer-global-6dc30">
    <div class="footer-global-6dc30__top-section">
      <!-- Company into section -->
      <div class="company-info-section-2f754 footer-global-6dc30__company-info-section">
        <RouterLink lang="en" hreflang="en" :to="{ name: 'Home' }">
          <img class="company-info-section-2f754__logo" src="https://cdn.shrpa.com/images/shrpa-full-color.png" alt="Shrpa" />
        </RouterLink>

        <div class="company-info-section-2f754__description">End-to-End UGC Solutions for Every Destination</div>

        <ul class="company-info-section-2f754__social-icons-row">
          <li class="company-info-section-2f754__social-icon">
            <a href="https://instagram.com/tryshrpa/" target="_blank" style="font: 1px/1px sans-serif"><IconEmbedded name="instagram" :size="23" /></a>
          </li>
          <li class="company-info-section-2f754__social-icon">
            <a href="https://facebook.com/tryshrpa" target="_blank" style="font: 1px/1px sans-serif"><IconEmbedded name="facebook" :size="23" /></a>
          </li>
          <li class="company-info-section-2f754__social-icon">
            <a href="https://www.linkedin.com/company/tryshrpa/" target="_blank" style="font: 1px/1px sans-serif"><IconEmbedded name="linkedin" :size="26" /></a>
          </li>
        </ul>
        <!-- / Company into section -->
      </div>

      <div class="footer-global-6dc30__link-columns-row" style="align-items: center">
        <!-- Links column -->
        <div class="links-column-470a7 footer-global-6dc30__links-column footer-global-6dc30__links-column--1">
          <h4 class="global-h4 links-column-470a7__title">Solutions</h4>

          <div class="links-column-470a7__links-list">
            <RouterLink lang="en" hreflang="en" :to="{ name: 'Home' }" class="links-column-470a7__link">For Destinations</RouterLink>
            <a class="links-column-470a7__link" href="https://explore.shrpa.com/become-a-creator-today/">For Creators</a>
            <RouterLink lang="en" hreflang="en" :to="{ name: 'Contact' }" class="links-column-470a7__link">Contact</RouterLink>
          </div>
        </div>
        <!-- / Links column -->

        <!--&lt;!&ndash; Links column &ndash;&gt;-->
        <!--<div class="links-column-470a7 footer-global-6dc30__links-column footer-global-6dc30__links-column&#45;&#45;3">-->
        <!--  <h4 class="global-h4 links-column-470a7__title">Resources</h4>-->

        <!--  <ul class="links-column-470a7__links-list">-->
        <!--    <li class="links-column-470a7__link">Blog</li>-->
        <!--    <li class="links-column-470a7__link">Glossary</li>-->
        <!--    <li class="links-column-470a7__link">Events</li>-->
        <!--  </ul>-->
        <!--</div>-->
        <!--&lt;!&ndash; / Links column &ndash;&gt;-->

        <!--&lt;!&ndash; Links column &ndash;&gt;-->
        <!--<div class="links-column-470a7 footer-global-6dc30__links-column footer-global-6dc30__links-column&#45;&#45;2">-->
        <!--  <h4 class="global-h4 links-column-470a7__title">Platform</h4>-->

        <!--  <ul class="links-column-470a7__links-list">-->
        <!--    <li class="links-column-470a7__link">User-Generated Content</li>-->
        <!--    <li class="links-column-470a7__link">Digital Asset Manager</li>-->
        <!--    <li class="links-column-470a7__link">Sharing Content</li>-->
        <!--    <li class="links-column-470a7__link">Member Management</li>-->
        <!--    <li class="links-column-470a7__link">Pricing</li>-->
        <!--  </ul>-->
        <!--</div>-->
        <!--&lt;!&ndash; / Links column &ndash;&gt;-->
      </div>
    </div>

    <div class="footer-global-6dc30__bottom-section">
      <div class="footer-global-6dc30__copyright-text">
        &copy; 2025 shrpa.com. <RouterLink lang="en" hreflang="en" :to="{ name: 'Terms' }" class="footer-global-6dc30__copyright-link">Terms</RouterLink> &
        <RouterLink lang="en" hreflang="en" :to="{ name: 'Privacy' }" class="footer-global-6dc30__copyright-link">Privacy</RouterLink>
      </div>

      <div class="footer-global-6dc30__additional-links-row">
        <!--<div class="footer-global-6dc30__additional-link">DCMA Policy</div>-->
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// Components
import IconEmbedded from "@components/ui/IconEmbedded.vue";
</script>

<style lang="scss">
@import "@/scss/screen-size-ranges.scss";
@import "@/scss/variables.scss";

// Company into section =======================================================
.company-info-section-2f754 {
  &__logo {
    width: 115px;
    margin-bottom: 10px;
  }

  &__description {
    margin-bottom: 25px;
  }

  &__social-icons-row {
    gap: 12px;
    padding: 0;
    margin: 0;
    display: flex;
    list-style: none;
  }

  &__social-icon {
    width: 43px;
    height: 43px;
    border-radius: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(230, 237, 240, 1);

    svg {
      fill: #113042;
    }
  }
}
// desktop wide -----------------------
@media (min-width: $desktop-wide-min-width) {
}
// desktop ----------------------------
@media (min-width: $desktop-min-width) and (max-width: $desktop-max-width) {
}
// laptop -----------------------------
@media (min-width: $laptop-min-width) and (max-width: $laptop-max-width) {
}
// tablet large -----------------------
@media (min-width: $tablet-large-min-width) and (max-width: $tablet-large-max-width) {
}
// tablet -----------------------------
@media (min-width: $tablet-min-width) and (max-width: $tablet-max-width) {
  .company-info-section-2f754 {
    display: flex;
    flex-direction: column;
    align-items: center;

    &__description {
      text-align: center;
    }
  }
}
// mobile -----------------------------
@media (max-width: $mobile-max-width) {
  .company-info-section-2f754 {
    display: flex;
    flex-direction: column;
    align-items: center;

    &__description {
      text-align: center;
    }
  }
}

// Links column ===============================================================
.links-column-470a7 {
  &__title {
    margin-bottom: 16px;
    color: #102f40;
  }

  &__links-list {
    gap: 12px;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    list-style: none;
  }

  &__link {
  }
}

// Footer global ==============================================================
.footer-global-6dc30 {
  width: calc($desktop-wide-grid-col-width * 10 + $desktop-wide-grid-gap-width * 9);
  @include standardFont;

  &__top-section {
    //padding-bottom: 40px;
    margin-bottom: 60px;
    //border-bottom: 1px rgba(0, 0, 0, 0.1) solid;
    display: flex;
  }

  &__company-info-section {
    width: calc($desktop-wide-grid-col-width * 3 + $desktop-wide-grid-gap-width * 2);
    margin-right: calc($desktop-wide-grid-col-width + $desktop-wide-grid-gap-width * 2);
  }

  &__link-columns-row {
    gap: $desktop-wide-grid-gap-width;
    display: flex;
  }

  &__links-column {
    width: calc($desktop-wide-grid-col-width * 2 + $desktop-wide-grid-gap-width);

    &--1 {
      order: 1;
    }
    &--2 {
      order: 2;
    }
    &--3 {
      order: 3;
    }
  }

  &__bottom-section {
    width: 100%;
    display: flex;
  }

  &__copyright-text {
    width: calc($desktop-wide-grid-col-width * 3 + $desktop-wide-grid-gap-width * 2);
    margin-right: calc($desktop-wide-grid-col-width + $desktop-wide-grid-gap-width * 2);
  }

  &__copyright-link {
    color: rgb(91, 91, 91);

    &:hover {
      text-decoration: underline;
    }
  }

  &__additional-links-row {
    gap: $desktop-wide-grid-gap-width;
    display: flex;
  }

  &__additional-link {
    width: calc($desktop-wide-grid-col-width * 2 + $desktop-wide-grid-gap-width);
  }
}
// desktop wide -----------------------
@media (min-width: $desktop-wide-min-width) {
}
// desktop ----------------------------
@media (min-width: $desktop-min-width) and (max-width: $desktop-max-width) {
  .footer-global-6dc30 {
    width: calc($desktop-grid-col-width * 10 + $desktop-grid-gap-width * 9);

    &__company-info-section {
      width: calc($desktop-grid-col-width * 3 + $desktop-grid-gap-width * 2);
      margin-right: calc($desktop-grid-col-width + $desktop-grid-gap-width * 2);
    }

    &__link-columns-row {
      gap: $desktop-grid-gap-width;
      display: flex;
    }

    &__links-column {
      width: calc($desktop-grid-col-width * 2 + $desktop-grid-gap-width);
    }

    &__copyright-text {
      width: calc($desktop-grid-col-width * 3 + $desktop-grid-gap-width * 2);
      margin-right: calc($desktop-grid-col-width + $desktop-grid-gap-width * 2);
    }

    &__additional-links-row {
      gap: $desktop-grid-gap-width;
      display: flex;
    }

    &__additional-link {
      width: calc($desktop-grid-col-width * 2 + $desktop-grid-gap-width);
    }
  }
}
// laptop -----------------------------
@media (min-width: $laptop-min-width) and (max-width: $laptop-max-width) {
  .footer-global-6dc30 {
    width: $laptop-content-width;

    &__company-info-section {
      width: calc($laptop-grid-col-width * 3 + $laptop-grid-gap-width * 2);
      margin-right: calc($laptop-grid-col-width * 2 + $laptop-grid-gap-width * 3);
    }

    &__link-columns-row {
      flex-grow: 1;
      gap: $laptop-grid-gap-width;
      display: flex;
    }

    &__links-column {
      width: calc(33.3% - $laptop-grid-gap-width * 2 / 3);
    }

    &__copyright-text {
      width: calc($laptop-grid-col-width * 3 + $laptop-grid-gap-width * 2);
      margin-right: calc($laptop-grid-col-width * 2 + $laptop-grid-gap-width * 3);
    }

    &__additional-links-row {
      flex-grow: 1;
      gap: $laptop-grid-gap-width;
      display: flex;
    }

    &__additional-link {
      width: calc(33.3% - $laptop-grid-gap-width * 2 / 3);
    }
  }
}
// tablet large -----------------------
@media (min-width: $tablet-large-min-width) and (max-width: $tablet-large-max-width) {
  .footer-global-6dc30 {
    width: $tablet-large-content-width;

    &__company-info-section {
      width: calc($tablet-large-grid-col-width * 3 + $tablet-large-grid-gap-width * 2);
      margin-right: $tablet-large-grid-gap-width;
    }

    &__link-columns-row {
      flex-grow: 1;
      gap: $tablet-large-grid-gap-width;
      display: flex;
    }

    &__links-column {
      width: calc(33.3% - $tablet-large-grid-gap-width * 2 / 3);
    }

    &__copyright-text {
      width: calc($tablet-large-grid-col-width * 3 + $tablet-large-grid-gap-width * 2);
      margin-right: $tablet-large-grid-gap-width;
    }

    &__additional-links-row {
      flex-grow: 1;
      gap: $tablet-large-grid-gap-width;
      display: flex;
    }

    &__additional-link {
      width: calc(33.3% - $tablet-large-grid-gap-width * 2 / 3);
    }
  }
}
// tablet -----------------------------
@media (min-width: $tablet-min-width) and (max-width: $tablet-max-width) {
  .footer-global-6dc30 {
    width: $tablet-content-width;

    &__top-section {
      margin-bottom: 40px;
      flex-direction: column;
      align-items: center;
    }

    &__company-info-section {
      width: 50%;
      margin: 0 auto 50px;
    }

    &__link-columns-row {
      width: 100%;
    }

    &__links-column {
      width: calc(33.3% - $tablet-grid-gap-width * 2 / 3);
    }

    &__bottom-section {
      flex-direction: column;
      align-items: center;
    }

    &__copyright-text {
      width: auto;
      margin: 0 auto 15px;
    }

    &__additional-links-row {
      width: 100%;
      justify-content: center;
    }

    &__additional-link {
      width: auto;
    }
  }
}
// mobile -----------------------------
@media (max-width: $mobile-max-width) {
  .footer-global-6dc30 {
    width: $mobile-content-width;

    &__top-section {
      margin-bottom: 40px;
      flex-direction: column;
      align-items: center;
    }

    &__company-info-section {
      width: 50%;
      margin: 0 auto 50px;
    }

    &__link-columns-row {
      display: block;
      column-count: 2;
      column-width: calc(50% - $mobile-grid-gap-width / 2);
      column-gap: $mobile-grid-gap-width;
    }

    &__links-column {
      width: 100%;
      margin-bottom: 30px;
      break-inside: avoid-column;
      page-break-inside: avoid;
    }

    &__bottom-section {
      flex-direction: column;
      align-items: center;
    }

    &__copyright-text {
      width: auto;
      margin: 0 auto 15px;
    }

    &__additional-links-row {
      width: 100%;
      gap: 10px 17px;
      justify-content: center;
      flex-wrap: wrap;
    }

    &__additional-link {
      width: auto;
    }
  }
}
</style>
